import React from 'react';
import './NoContent.scss';

const NoContent = ({children})=>{
    return (<div className="empty-content-wrapper" >
        <div className="empty-content">{children || 'Aucune publication à afficher 😞'}</div>
    </div>)
}

export default NoContent;